import { AxiosError } from 'axios'

import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface GetPatientEmotionalHealthEvaluationProps {
  patientUuid: string
}

interface PatientEmotionalHealthEvaluationData {
  formId: string
  uuid: string
}

interface Response {
  data: {
    form_id: string
    uuid: string
  }
}

const getPatientEmotionalHealthEvaluation = ({
  patientUuid
}: GetPatientEmotionalHealthEvaluationProps): Promise<PatientEmotionalHealthEvaluationData> => {
  const endpoint = apiEndpoints.EMOTIONAL_HEALTH_EVALUATION(patientUuid)

  return new Promise<PatientEmotionalHealthEvaluationData> ((resolve, reject) => {
    axios.get(endpoint)
      .then((response: Response) => resolve({
        formId: response.data.form_id,
        uuid: response.data.uuid
      }))
      .catch(((err: AxiosError) => reject(err.response?.status)))
  })
}

export {
  getPatientEmotionalHealthEvaluation
}